export const userId = Number(localStorage.getItem("userId"));
export const customerNo = Number(localStorage.getItem("customerNumber"));
export const COOKIE_USER_TOKEN = localStorage.getItem('isloggedIn')
export const COOKIE_USER_ID = localStorage.getItem('userId');

// 'Date Formats'
export const role = localStorage.getItem("role");
export const DATE_DDMMyyyy = 'DD/MM/yyyy';
export const YYYYMM = 'YYYY-MM';
export const YYYYMMDDHHmmss = 'YYYY-MM-DD HH:mm:ss';
export const DDMMYYYYHHmmss = "DD-MM-YYYY HH:mm:ss"
export const DATE_DDMMYYYY = 'DD-MM-YYYY';
export const DATE_ddMMYYYY = 'dd-MM-yyyy';
export const DATE_YYYYMMDD = 'YYYY-MM-DD';
export const DATE_MMYYYY = 'MM/yyyy';
export const YYYYMMDD_HHMM = 'YYYY-MM-DD HH:mm'
export const ddMMyyy_HHmm = "dd-MM-yyyy HH:mm"
export const HHmm = "HH:mm"
export const DD_MM_yyyy = "DD-MM-yyyy"
export const DD_MM_YYYY_HH_mm = 'DD-MM-YYYY HH:mm'
export const YYYY_MM_DD = "YYYY-MM-DD"

export const DATE_FORMATS = {
    DATE_DDMMyyyy,
    YYYYMM,
    YYYYMMDDHHmmss,
    DDMMYYYYHHmmss,
    DATE_DDMMYYYY,
    DATE_ddMMYYYY,
    DATE_YYYYMMDD,
    DATE_MMYYYY,
    YYYYMMDD_HHMM,
    ddMMyyy_HHmm,
    HHmm,
    DD_MM_yyyy,
    DD_MM_YYYY_HH_mm,
    YYYY_MM_DD,
    ddMMyyyy: 'dd/MM/yyyy',
    DDMMYYYHHmm: "DD-MM-YYYY | HH:mm",
    hhmm: "hh:mm",
    dd_MM_yyyy_HH_mm: "dd/MM/yyyy HH:mm",
    MMddyyyy: "MM/dd/yyyy",
    DDMMYYYY: "DD/MM/YYYY",
    DD_MM_YYYY_hh_mm_a : "DD-MM-YYYY hh:mm a"
}

// 'Features'
export const TA_MODULE = 'TA'
export const reportNames = {
    DAILY_PLACEMENT_DASHBOARD: 'Daily Placement Dashboard'
}
export const requireConsignrConsigneeMastersInBookings = ![549].includes(Number(customerNo));
export const requireBillingPartyInBookings = [1158].includes(Number(customerNo));
export const isReemaClient = [549].includes(Number(customerNo));
export const orderDetailsAccess = [1122].includes(Number(customerNo));
export const scheduleOrderDetailsAccess = [1330].includes(Number(customerNo));
export const billingPartyOrderDetailsAccess = [1122, 549].includes(Number(customerNo));
export const deliverOrderDetailsAccess = [549, 1341].includes(Number(customerNo));
export const noLogoCustomerInSidebar = [1330].includes(Number(customerNo));
export const sideBarOptionsHide = [1122].includes(Number(customerNo));
export const dashboardLinkCustomer = [503, 549, 1568].includes(Number(customerNo));
export const bookingRequestIndentLinkName = [1158].includes(Number(customerNo));
export const bookingRequestOrdersLinkNameAndShipment = [503].includes(Number(customerNo));
export const myProfileHideCustomer = [1166].includes(Number(customerNo));
export const remarksOnUndoAllotVendor = [1305].includes(Number(customerNo));
export const orderNoTitleCustomer = [1166].includes(Number(customerNo));
export const ordersHeaderNoImport = [1375, 503, 1562, 1545,1920, 1922, 2090, 2087].includes(Number(customerNo));
export const order_header_no_primary = [1122].includes(Number(customerNo));
export const usePartnerInsteadOfVendor = [1158].includes(Number(customerNo));
export const order_header_secondary_import_className = [1122].includes(Number(customerNo));
export const alloted_orders_grid_state = [1122].includes(Number(customerNo));
export const alloted_orders_quantity = [1330].includes(Number(customerNo));
export const enablePOInBills = [549, 503, 1360, 353,1330].includes(Number(customerNo));


export const billingPartyAvailNotAllowed = [1122, 984, 1167, 1123, 1077, 1305].includes(Number(customerNo));
export const order_import_movement_type = [1122].includes(Number(customerNo));
export const handleOrderApiCallOrder = [1122].includes(Number(customerNo));
export const allocationAccess = [1158].includes(Number(customerNo));
export const orderAgGridCoulumnDef = [1122].includes(Number(customerNo));
export const shouldShowDeliveryReferenceNumberOrderAgGrid = [1123].includes(Number(customerNo));
export const shouldShowSuggestedVendorOrderAgGrid = [1123].includes(Number(customerNo));
export const shouldShowDispatchLocationOrderAgGrid = [1123].includes(Number(customerNo));
export const shouldHideBookingNumberOrderAgGrid = [1122].includes(Number(customerNo));
export const shouldShowRemarksOrderAgGrid = [1123, 1305].includes(Number(customerNo));
export const dailyPlacementDashboard = [1305].includes(Number(customerNo));
export const SOBReport = [1305].includes(Number(customerNo));
export const isLrProfitabilityReportEnabled = [549].includes(Number(customerNo));
export const isDumpAnalysisReportEnabled = [503, 1305].includes(Number(customerNo));
export const isTripDistanceAnalysisReportEnabled = [1077].includes(Number(customerNo));
export const isMISReportEnabled = [1375,1562,1922].includes(Number(customerNo));
export const isLRDumpReportEnabled = [1568,1413,549,1931].includes(Number(customerNo));
export const isPlacementAnalysisReportEnabled = [1568].includes(Number(customerNo));
export const isQuicksightReportEnabled = [1568, 1375, 1158, 1305, 503, 1330, 1654, 1166,1562].includes(Number(customerNo));
export const isReportsEnabled = [549, 503, 1305, 1158, 1123, 1077, 1330, 1375, 1568,1413, 1654, 1166,1562, 1922, 1931].includes(Number(customerNo));
// 'Other Constants'
export const statusOptions = {
    ACCEPTED: 'Accepted',
    ALLOCATED: 'Allocated',
    COMPLETED: 'Completed',
    WAITING_FOR_VEHICLE_DETAILS: 'Waiting for vehicle details',
    REJECTED: 'Rejected',
    CREATED: 'Created',
    BROADCASTED: 'Broadcasted',
    CANCELLED: 'Cancelled',
}
export const canAddRadarAndSpeedUserKeysInVendorMaster = ['Elixir'].includes(role);


export const ALL_ALLOW_ROLES = ["ADMINISTRATOR", "ELIXIR","PLANT USER"].includes(role?.toString().toUpperCase())
export const consigneeModuleName = 'consignee_app'
export const consignorModuleName = 'consignor_app'
export const consigneeConsignorCheck = (role) => ['Consignor', 'Consignee'].includes(role)
export const UPL_CUSTOMER = [1122].includes(Number(customerNo));
export const snowmanCustomer = [1158].includes(Number(customerNo));
export const licenseKey = "Elixia_Tech_Solutions_Ltd_MultiApp_1Devs16_March_2019__MTU1MjY5NDQwMDAwMA==c4c29e5702e62789dbdb799433c73545"
export const deleteSuccess = "Deleted successfuly.";
export const ShipmentUndoBtnDisabled = ["Quality Control", "Broker"].includes(localStorage.getItem('role'))
export const shipmentTableBookingNumberHeaderCell = [503].includes(Number(customerNo));
export const billingPartyUserAccess = [503, 1360, 549, 353].includes(Number(customerNo));
export const vendor_Id = localStorage.getItem("vendorId")
export const time_zone = localStorage.getItem("timezone");
export const is_logged_in = localStorage.getItem("isloggedIn");
export const dipatch_loc_hide_in_alloted_orders = [1123].includes(Number(customerNo));
export const consigneeId = localStorage.getItem('consigneeId')
export const consignorId = localStorage.getItem('consignorId')
export const deliveryCode_ALLOC = 'ALLOC'
export const deliveryCode_CANCEL = "CANCEL"
export const deliveryCode_LOADING_GATEOUT = "LOADING-GATEOUT"
export const branch_Ids = localStorage.getItem('branchIds')
export const billing_Party_Branch_Ids = localStorage.getItem("billingpartbranchIds")
export const billing_Party_Ids = localStorage.getItem("billingpartIds");

export const order_allotment_status = {
    broadcast: "BRDCST",
    reject: "REJECT",
    allocated: "ALLOC",
    accepted: "ACK",
    waitingForVehicle: "WAITINGVEH",
    completed: "COMPLETE",
    tripCreationInProcess : "WAITRIP"
}
export const ORDER_ALLOCATED_STATUS = {
    REJECT: 'REJECT',
    ALLOC: 'ALLOC',
    ACK: 'ACK',
    WAITINGVEH: 'WAITINGVEH',
    BRDCST: 'BRDCST'
}
export const noModalUndoBroadcastRoles = ["Quality Control", "Broker"].includes(localStorage.getItem('role'))
export const noModalAllotRole = ["Quality Control"].includes(localStorage.getItem('role'))
export const noModalBroadcastRole = ["Quality Control"].includes(localStorage.getItem('role'))

export const LOCAL_STORAGE = {
    customerNo,
    userId,
    role,
    userToken: localStorage.getItem('isloggedIn'),
    branch_Ids,
    billing_Party_Branch_Ids,
    billing_Party_Ids,
    vendor_Id,
    customerLogo: localStorage.getItem('customerLogo'),
    vendorCode: localStorage.getItem('vendorCode'),
    locales: localStorage.getItem("locales"),
    freightDetail: localStorage.getItem('freightDetail'),
    set: (name, value) => localStorage.setItem(name, value),
    captcha_token: localStorage.getItem("captcha_token")
}
export const noModalMapDelivery = ["Quality Control"].includes(localStorage.getItem('role'))

export const mastersExportDisabled = ()=>{
    switch(customerNo.toString()){
        case '1545':
         return ["ADMINISTRATOR", "ELIXIR"].includes(role?.toString().toUpperCase()) ? false : true;
        default : 
         return false;
    }
}

export const whatsappConsentFieldEnabled = ()=>{
    switch(customerNo.toString()){
        case '2':
         return ["ELIXIR"].includes(role?.toString().toUpperCase()) ? true : false;
        default : 
         return false;
    }
}

export const customerLabelNames = ()=>{
    switch(customerNo.toString()){
        case '1158':
         return {
            vendor_lr_no : "Snowman LR Number"
         }
        default : 
         return false;
    }
}

export const FEATURES = {
    requireConsignrConsigneeMastersInBookings,
    requireBillingPartyInBookings,
    isReemaClient,
    orderDetailsAccess,
    scheduleOrderDetailsAccess,
    billingPartyOrderDetailsAccess,
    deliverOrderDetailsAccess,
    noLogoCustomerInSidebar,
    sideBarOptionsHide,
    dashboardLinkCustomer,
    bookingRequestIndentLinkName,
    bookingRequestOrdersLinkNameAndShipment,
    myProfileHideCustomer,
    remarksOnUndoAllotVendor,
    orderNoTitleCustomer,
    ordersHeaderNoImport,
    order_header_no_primary,
    usePartnerInsteadOfVendor,
    order_header_secondary_import_className,
    alloted_orders_grid_state,
    billingPartyAvailNotAllowed,
    order_import_movement_type,
    handleOrderApiCallOrder,
    allocationAccess,
    orderAgGridCoulumnDef,
    shouldShowDeliveryReferenceNumberOrderAgGrid,
    shouldShowSuggestedVendorOrderAgGrid,
    shouldShowDispatchLocationOrderAgGrid,
    shouldHideBookingNumberOrderAgGrid,
    shouldShowRemarksOrderAgGrid,
    dailyPlacementDashboard,
    canAddRadarAndSpeedUserKeysInVendorMaster,
    ALL_ALLOW_ROLES,
    ShipmentUndoBtnDisabled,
    shipmentTableBookingNumberHeaderCell,
    billingPartyUserAccess,
    dipatch_loc_hide_in_alloted_orders,
    noModalUndoBroadcastRoles,
    noModalAllotRole,
    noModalBroadcastRole,
    noModalMapDelivery,
    masterTitleVendor: [1158].includes(Number(customerNo)),
    masterTitleVendorShare: [1158].includes(Number(customerNo)),
    masterTitleVendorGroup: [1158].includes(Number(customerNo)),
    noBillingPartyAndBranchMaster: [1122].includes(Number(customerNo)),
    orderPlacementRatioAndInTransitVehiclesShown: [1158, 1123].includes(Number(customerNo)),
    partnerPerformenceDashboardShown: [1158].includes(Number(customerNo)),
    oneTimePlacementAnalysisShown: [1123].includes(Number(customerNo)),
    performenceEfficiencyShown: [1330].includes(Number(customerNo)),
    tripDistanceAnalysisShown: [1077].includes(Number(customerNo)),
    dumpAnalysisReportShown: [503, 1305].includes(Number(customerNo)),
    accorditionContentShownAsideDropdown: [503, 1305, 1158, 1123, 1077, 1330].includes(Number(customerNo)),
    constactPersonNoRequiredInVendorMaster: [1360].includes(Number(customerNo)),
    stuffingDateTitleInBookings: [1327].includes(Number(customerNo)),
    performanceEffireincyReport: [1330].includes(Number(customerNo)),
    ordersReport: [1330].includes(Number(customerNo)),
    isSkuUnitMandatoryInSku: [].includes(Number(customerNo)),
    isWeightMandatoryInSku: [].includes(Number(customerNo)),
    isVolumeMandatoryInSku: [].includes(Number(customerNo)),
    isNetGrossMandatoryInSku: [].includes(Number(customerNo)),
    isHeightMandatoryInSku: [].includes(Number(customerNo)),
    isWidthMandatoryInSku: [].includes(Number(customerNo)),
    isLengthMandatoryInSku: [].includes(Number(customerNo)),
    isDescMandatoryInSku : [].includes(Number(customerNo)),
    disableStatusDetailsInAllocatedOrders: [1305].includes(Number(customerNo)),
    disablePODDetailsInAllocatedOrders: [1122, 1305].includes(Number(customerNo)),
    pickupAndDropDetailsInAllocatedOrders: [1122].includes(Number(customerNo)),
    userBusinessUnitField: [1158, 1545].includes(Number(customerNo)),
    requestedStuffingDateHeading: [1327].includes(Number(customerNo)),
    portTerminalNotRequired: [549].includes(Number(customerNo)),
    deliveryLocationNotRequired: [549].includes(Number(customerNo)),
    hideInvoiceDetails: [1327].includes(Number(customerNo)),
    billingPartyInBookingsRequired: [1158].includes(Number(customerNo)),
    bookingInvoiceDetails: ![1327].includes(Number(customerNo)),
    bookingBillingParty: ![1158].includes(Number(customerNo)),
    bookingDelivery: [1158].includes(Number(customerNo)),
    bookingConsignorCodeDeliveryLoc: [549].includes(Number(customerNo)),
    bookingExportPickup: [1327].includes(Number(customerNo)),
    chaMasterEnable: [1568, 1114, 549].includes(Number(customerNo)),
    yardEnable: [1568, 1114, 549].includes(Number(customerNo)),
    shippingLineEnable: [1568, 1114, 549].includes(Number(customerNo)),
    bookingDateReadOnly: [1158].includes(Number(customerNo)),
    elevenNumberValidation: [1122].includes(Number(customerNo)),
    simcardTrackingTypeCust: [1379].includes(Number(customerNo)),
    trackingTypeFilter: [1166].includes(Number(customerNo)),
    vehicleOwnerShipOptional: [1122].includes(Number(customerNo)),
    hideGPSAvailableField: [1122].includes(Number(customerNo)),
    hideVehicleDocumentsSection: [1122].includes(Number(customerNo)),
    hideNetworkProviderAndLicExpiryFields: [1122].includes(Number(customerNo)),
    hideDataLoggerField: [1122].includes(Number(customerNo)),
    brazilVehiclelicenseValidation: [1122].includes(Number(customerNo)),
    frozenAsRefeer: [549].includes(Number(customerNo)),
    billingPartyAndBranchRequiredInCreateOrder: [1183].includes(Number(customerNo)),
    orderPageHeadingAsBookingDetails: [503].includes(Number(customerNo)),
    createOrderhideFields: [1122].includes(Number(customerNo)),
    createOrderShowModeOfTransport: [1330].includes(Number(customerNo)),
    createOrderBillingPartySeparateComponent: [549].includes(Number(customerNo)),
    createOrderHideBillingPartyComponent: [549, 1183].includes(Number(customerNo)),
    createOrderBillingPartyOnlyForPrimary: [1183].includes(Number(customerNo)),
    createOrderDeliverTo: [549].includes(Number(customerNo)),
    createOrderShowContainerPickupDate: [1327].includes(Number(customerNo)),
    createOrderShowDemurageExpiration: [1327].includes(Number(customerNo)),
    billingPartyFreightDetailsTitle: [1360].includes(Number(customerNo)),
    lineItemsTitleForRemarks: [1166].includes(Number(customerNo)),
    orderDetails_GetBillingPartyTypeMapping: [503, 1360, 549, 353].includes(Number(customerNo)),
    orderDetails_setConsignorDetails: [1183].includes(Number(customerNo)),
    orderDetails_showDropLocation: [1327].includes(Number(customerNo)),
    showVendoAdvance_vendorAllotModal: [1360].includes(Number(customerNo)),
    remarksRequired_vendorAllotModal: [1165, 1166].includes(Number(customerNo)),
    showUpdateEwayBill_VehicleAllocation: [1568].includes(Number(customerNo)),
    driverMaster_panNo_required: [549].includes(Number(customerNo)),
    driverMaster_aadharNo_required: [549].includes(Number(customerNo)),
    driverMaster_dlExpiry_required: [1568, 549].includes(Number(customerNo)),
    driverMaster_licNo_required: [1568].includes(Number(customerNo)),
    driverMaster_show_driverBankDetails: [1360].includes(Number(customerNo)),
    driverMaster_show_residentialAddress: [549].includes(Number(customerNo)),
    driverMaster_show_permanentAddress: [549].includes(Number(customerNo)),
    driverMaster_show_alternateNameAndMobileNo: [549].includes(Number(customerNo)),
    driverMaster_show_guarantorNameAndMobileNo: [549].includes(Number(customerNo)),
    driverMaster_show_dateOfJoining: [549].includes(Number(customerNo)),
    driverMaster_show_driverLeftCheckbox: [549].includes(Number(customerNo)),
    driverMaster_alternateName_required: [549].includes(Number(customerNo)),
    driverMaster_alternateMob_required: [549].includes(Number(customerNo)),
    driverMaster_guarantorName_required: [549].includes(Number(customerNo)),
    driverMaster_guarantorMob_required: [549].includes(Number(customerNo)),
    driverMaster_dateOfJoining_required: [549].includes(Number(customerNo)),
    orderExport_redirect_to_orderReport: [1330].includes(Number(customerNo)),
    user_login_history: [1330].includes(Number(customerNo)),
    lr_series_activated : [1423,1341,1931,2001,2055].includes(Number(customerNo)),
    lr_series_fixed_customer : [1341].includes(Number(customerNo)),
    lr_series_fixed : (vendor_name) => [1341].includes(Number(customerNo)) && ["SAKINAKA"].includes(vendor_name?.toString().toUpperCase()),
    CHECK_ALL_ALLOW_ROLE : (role_name)=> ["ADMINISTRATOR", "ELIXIR","PLANT USER"].includes(role_name?.toString().toUpperCase()) ,
    enable_vehicle_type_while_allocation : [1330].includes(Number(customerNo)),
    RestrictGenerateOrderFromBookings : (status) => ["Rejected", "Completed","Cancelled","Waiting For Approval"].includes(status),
    isExpectedPaymentDateDisabledInCreateBill : [1166].includes(Number(customerNo)),
    isDefaultExpectedPaymentDateNeededInCreateBill : [1166].includes(Number(customerNo)),
    creditCheckRequired : [1568].includes(Number(customerNo)),
    transactionDetailsEnabled : [1166].includes(Number(customerNo)),
    hideShipmentNewBtn : [1158, 1568].includes(Number(customerNo)),
    editBillingPartyAfterAllocation : [1568].includes(Number(customerNo)),
    flutterOEEnabled : [1654,1920, 1562].includes(Number(customerNo)),
    dumpDashboardEnabled : [1654,1922].includes(Number(customerNo)),
    flutterBillingEnabled : true,
    flutterSalesEnabled : ![1330].includes(Number(customerNo)),
    flutterConsignorModuleEnabled : [1654,1922, 1920, 1562].includes(Number(customerNo)),
    flutterConsigneeModuleEnabled : [1922, 1920, 1562, 1166].includes(Number(customerNo)),
    flutterDTEnabled : [1375,1330,1562,1305 ].includes(Number(customerNo)),
    uomWiseCalculationEnabled : [1931].includes(Number(customerNo)),
    rateEngineExceptionReportEnabled : [1166].includes(Number(customerNo)),
    mastersExportDisabled,
    contractualCustomerFieldEnabled : [1568].includes(Number(customerNo)),
    whatsappConsentFieldEnabled,
    isCaptchaOptional : [2].includes(Number(customerNo)),
    weightInTonCustomers : [1931,2055].includes(Number(customerNo)),
    pincodeOptionalForConsigneeMaster: [1920].includes(Number(customerNo)),
    pincodeOptionalForConsignorMaster: [1920].includes(Number(customerNo)),
    uaeVehicleCustomer : [1920].includes(Number(customerNo)),
    enabledPreferredLocationAndVehicleType : [2].includes(Number(customerNo)),
    isolationAndLoadTypeEnabledInProductCategory : [1920].includes(Number(customerNo)),
    customerLabelNames,
    partitionInVehicleType : [1920].includes(Number(customerNo)),
    actWeightWarningOnDeliveryUpdation : [1568].includes(Number(customerNo)),
    weightAutoFillingInDelivery : [1568].includes(Number(customerNo)),
    vehicleAvailabilityExpandedViewByDefault : [1158].includes(Number(customerNo)),
    allotVendorOptionForBroadcastedOrders : [1158].includes(Number(customerNo)),
    branchContactPersonMandatory : [1158].includes(Number(customerNo)),
    showConsignorConsigneeInOrderCard : [1562,1166].includes(Number(customerNo)),
    brokerInsteadOfSalesPerson : [2028].includes(Number(customerNo)),
    productFilterEnabled : [1922].includes(Number(customerNo)),
    redirectToFlutterOnInvoice : [1330].includes(Number(customerNo)),
}

export const orderStatusSmall = {
    alloted: 'alloted',
    active: 'active',
    reporting: 'reporting'
}

export const reportTitle = {
    PERFORMANCE_EFFICIENCY: 'Performance Efficiency',
    ORDERS_REPORT: 'Orders Report',
    MIS_REPORT: 'MIS Report',
    LR_DUMP: 'LR Dump Report',
    USER_LOGIN_HISTORY: 'User Login History',
    PLACEMENT_ANALYSIS : "Placement Analysis",
    DUMP_DASHBOARD : "Dump Dashboard",
    RATE_ENGINE_EXCEPTION_REPORT : "Rate Engine Exception Report"
}

export const headerFields = {
    IMPORT: 'Import'
}
export const genericConstants = {
    NA : "NA"
}

export const TransactionTypes = {
    PO : 'PO',
    SO : 'SO',
    STO : "STO",
    OTHERS : 'Other' 
}

export const getFieldLength = (fieldname)=>{
    switch(fieldname){
        case 'branchCode' : 
        switch(customerNo){
            case 1166 : return 4;
            default : break;
        }
        break;

        case 'vendorCode' : 
        switch(customerNo){
            case 1166 : return 17; 
            default : break;
        }
        break;

        default: break;
    }
}